import * as THREE from 'three';

export const NODE_CORE_RADIUS = 0.155;
export const TITLE_RIMS = [0.52, 0.64, 0.76, 0.9, 1.08, 1.26];
export const TITLE_PUSH = [0, 0.28, 0.55, 0.9, 1.35, 1.9, 2.5, 3.3];
export const VIEW_PAD_PX = 12;
/** Screen-space follow when a title slides back onto the visible cloud. */
export const VIEW_FOLLOW = 0.14;

export const tagWorld = new THREE.Vector3();
export const ndc = new THREE.Vector3();
export const ndc2 = new THREE.Vector3();
export const right = new THREE.Vector3();
export const fwd = new THREE.Vector3();
export const ray = new THREE.Ray();
export const hit = new THREE.Vector3();
export const plane = new THREE.Plane();
export const nodeScreens = [];
export const wireScreens = [];
